export const marketGroupsSortingFunction = (a, b) => (a.order || Infinity) - (b.order || Infinity);
export const createFavouriteCategoriesService = (s) => ({
    loadFavouriteCategories: () => s.load(),
    saveFavouriteCategories: (favouritesCategories) => s.save(favouritesCategories),
    addToFavouriteCategories: (favouritesCategory) => {
        const favouritesCategories = s.load();
        if (favouritesCategories.includes(favouritesCategory))
            return favouritesCategories;
        favouritesCategories.unshift(favouritesCategory);
        s.save(favouritesCategories);
        return s.load();
    },
    removeFromFavouriteCategories: (favouritesCategory) => {
        const favouritesCategories = s.load();
        if (!favouritesCategories.includes(favouritesCategory))
            return favouritesCategories;
        s.save(favouritesCategories.filter(category => category !== favouritesCategory));
        return s.load();
    },
    getMarketsDataWithFavourites: (marketsData, favouritesCategories) => {
        const favouritesInOrder = [];
        favouritesCategories.forEach(favouriteCategory => {
            const marketGroup = (marketsData.byoMarketGroups || []).find((g) => g.category === favouriteCategory);
            if (!marketGroup)
                return;
            favouritesInOrder.push(Object.assign(Object.assign({}, marketGroup), { favourite: true }));
        });
        const rest = (marketsData.byoMarketGroups || [])
            .filter((g) => !favouritesCategories.includes(g.category))
            .map((g) => (Object.assign(Object.assign({}, g), { favourite: false })))
            .sort(marketGroupsSortingFunction) || [];
        return Object.assign(Object.assign({}, marketsData), { byoMarketGroups: favouritesInOrder.concat(rest) });
    },
});
